import React, { forwardRef } from "react";
import { TableCell, TableRow } from "@mui/material";
import { useNavigate } from "react-router";
import MenuComponent, { MenuItem } from "components/MenuComponent";
import { Admin } from "../../model";
import { hasPermission } from "core/utils/roles";

interface TableRowProps {
  row: Admin;
  attributes: { [key: string]: any };
}

const AdminUsersRow = forwardRef<HTMLTableRowElement, TableRowProps>(
  (props) => {
    const navigate = useNavigate();
    const row = props.row;
    const attributes = props.attributes;

    const options: MenuItem[] = [
      {
        label: hasPermission("update:admin-onboarding")
          ? "Edit"
          : "View",
        onClick: () => navigate("/admin-users/add-edit/" + row.id),
      },
    ];

    return (
      <>
        <TableRow
          sx={{ borderBottom: "none", "& > *": { borderBottom: "unset" } }}
        >
          <TableCell>{row?.name}</TableCell>
          <TableCell>{row?.username}</TableCell>
          <TableCell>{row?.email || "N/A"}</TableCell>
          <TableCell>{row?.role}</TableCell>
          <TableCell>{row?.system_to_system ? "S2S" : "User"}</TableCell>
          <TableCell>
            <MenuComponent options={options} />
          </TableCell>
        </TableRow>
      </>
    );
  }
);

export default AdminUsersRow;
